<template>
  <header>
    <div class="flex flex-col">
      <div class="flex max-lg:items-center max-lg:justify-between max-lg:px-3.75">
        <BurgerMenu></BurgerMenu>
        <div>
          <router-link to="/">
            <AppLogo />
          </router-link>
        </div>
        <div class="ml-auto flex items-center gap-10 max-lg:hidden">
          <CategoriesDropdown :content="publicationCategories">
            <template v-slot:title>
              {{ $t('page.categories') }}
              <span
                class="absolute -top-1 -right-5 text-center text-sm rounded-full bg-red-500 text-white font-normal aspect-square w-5 h-5"
                v-if="getLastSeenPublicationsCount > 0"
                >{{ getLastSeenPublicationsCount }}</span
              >
            </template>
          </CategoriesDropdown>
          <router-link
            :to="{ name: 'publicationLiked' }"
            class="relative text-black font-bold text-lg"
          >
            {{ $t('nav.liked') }}
            <span
              class="absolute -top-1 -right-4 text-center text-sm rounded-full bg-red-500 text-white font-normal aspect-square w-5 h-5"
              v-if="getPublicationLikedCount > 0"
              >{{ getPublicationLikedCount }}</span
            >
          </router-link>
          <router-link
            :to="{ name: myPublicationsRouteName }"
            class="relative text-black font-bold text-lg"
          >
            {{ $t('nav.myPublications') }}
            <span
              class="absolute -top-1 -right-8 text-center text-sm rounded-full bg-green-600 text-white font-normal aspect-square w-5 h-5"
              v-if="getLastSeenMyAcceptedPublicationsCount > 0"
              >{{ getLastSeenMyAcceptedPublicationsCount }}</span
            >
            <span
              class="absolute -top-1 -right-3 text-center text-sm rounded-full bg-red-500 text-white font-normal aspect-square w-5 h-5"
              v-if="getLastSeenRejectedPublicationsCount > 0"
              >{{ getLastSeenRejectedPublicationsCount }}</span
            >
          </router-link>
          <div class="flex">
            <LocationButton></LocationButton>
            <div class="ml-4">
              <ProfileButton></ProfileButton>
            </div>
          </div>
        </div>
        <div class="hidden max-lg:flex">
          <LocationButton customClass="mr-4 bg-[#f9f9f9] shadow-sm"></LocationButton>
          <LanguageSwitcher
            extraclasswrapper="border-black"
            extraclasslabel="!text-black"
          ></LanguageSwitcher>
        </div>
      </div>
      <div class="hidden max-lg:flex max-lg:mt-5 bg-white">
        <MiddleNav></MiddleNav>
      </div>
      <div class="mt-5" v-if="showSearchBar">
        <SearchBar
          section="publication"
          :placeholder="$t('page.searchPublicationByName')"
        ></SearchBar>
      </div>
    </div>
  </header>
</template>

<script>
import AppLogo from '@cmp/AppLogo.vue';
import LanguageSwitcher from '@cmp/LanguageSwitcher.vue';
import ProfileButton from '@cmp/ProfileButton.vue';
import SearchBar from '@cmp/SearchBar.vue';
import CategoriesDropdown from '@cmp/publication/CategoriesDropdown.vue';
import LocationButton from '@cmp/LocationButton.vue';
import BurgerMenu from '@cmp/BurgerMenu.vue';
import MiddleNav from '@cmp/MiddleNav.vue';
import { mapState } from 'pinia';
import { useAppStore } from '@/store';
export default {
  name: 'PublicationHeader',
  components: {
    AppLogo,
    CategoriesDropdown,
    ProfileButton,
    LocationButton,
    SearchBar,
    BurgerMenu,
    LanguageSwitcher,
    MiddleNav,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {},
  computed: {
    ...mapState(useAppStore, [
      'getPublicationLikedCount',
      'getLastSeenPublicationsCount',
      'getLastSeenMyAcceptedPublicationsCount',
      'getLastSeenRejectedPublicationsCount',
    ]),
    publicationCategories() {
      return this.$store.publicationCategories;
    },
    showSearchBar() {
      return this.$route?.name !== 'publicationHome';
    },
    myPublicationsRouteName() {
      return this.$store.userData?.has_business_account
        ? 'myBusinessPublications'
        : 'myPublications';
    },
  },
  created() {},
};
</script>
<style scoped>
.router-link-exact-active {
  color: #409dba;
}
</style>
